/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Outlook_Reconnect_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to upgrade Outlook permissions. Please try again." |
*
* @param {Spaces_Outlook_Reconnect_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_outlook_reconnect_error = /** @type {((inputs?: Spaces_Outlook_Reconnect_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Outlook_Reconnect_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Outlook-Berechtigungen konnten nicht aktualisiert werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Failed to upgrade Outlook permissions. Please try again.")
});